import Immutable, { Record } from 'immutable';

const CategoryItemReacord = Record({
  cicCategoryItemId: undefined,
  cicCategoryItemName: undefined,
  orderingSequence: undefined,
  isChecked: true,
});

class CategoryItem extends CategoryItemReacord { }

const reviver = ([key, val]) => {
  switch (key) {
    case 'cicCategoryItemName':
      return [key, `${val}`];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

CategoryItem.create = (data) =>
  new CategoryItem(data).mapEntries(reviver);

export default CategoryItem;



// WEBPACK FOOTER //
// ./data/CoveredInClass/Category/CategoryItem/model.js